import type { FC } from 'react'

import { Input } from '@skytech/ui'
import type { FieldProps } from 'formik'
import { Field } from 'formik'

import Text from '@/app/translations/Text'

export const ConfirmationOptOutSubscription: FC<{
  isEditable: boolean
}> = ({ isEditable }) => (
  <section>
    <h3>
      <Text id="Confirmation" />
    </h3>

    <div className="inputs">
      <Field name="comment">
        {({ field, meta }: FieldProps) => (
          <Input
            id="comment"
            marginRight={16}
            label={<Text id="Reason" />}
            error={meta.error}
            touched={meta.touched}
            isDisabled={!isEditable}
            {...field}
          />
        )}
      </Field>
    </div>
  </section>
)
